import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import { MenuCategory } from 'types/menuCategory';
import {
  RegistrationStep,
  REGISTRATION_STEP,
} from '../../../constants/registrationStep';

/**
 * メニューの登録画面の状態
 */
interface MenuRegistrationState {
  /** 登録モーダル表示フラグ */
  isOpen: boolean;
  /** 登録ステップ */
  step: RegistrationStep;
  /** 登録先のカテゴリーID */
  categoryId: MenuCategory['id'] | null;
}

/**
 * メニュー登録画面の初期状態
 */
const initialState: MenuRegistrationState = {
  isOpen: false,
  step: REGISTRATION_STEP.INPUT,
  categoryId: null,
};

/**
 * メニュー登録画面の slice(reducer + action)
 */
export const menuRegistrationSlice = createSlice({
  name: 'registrationMenu',
  initialState,
  reducers: {
    initialize: () => initialState,
    modalOpened: (
      state,
      { payload }: PayloadAction<MenuRegistrationState['categoryId']>,
    ) => ({
      ...state,
      isOpen: true,
      categoryId: payload,
    }),
    updateStep: (
      state,
      { payload }: PayloadAction<MenuRegistrationState['step']>,
    ) => ({
      ...state,
      step: payload,
    }),
  },
});

/**
 * メニュー登録画面の action
 */
export const menuRegistrationActions = menuRegistrationSlice.actions;

/**
 * メニュー登録画面の selectors
 */
export const menuRegistrationSelectors = {
  isOpenModal: (state: RootState) => state.menuCategory.menuRegistration.isOpen,
  currentModalStep: (state: RootState) =>
    state.menuCategory.menuRegistration.step,
  categoryId: (state: RootState) =>
    state.menuCategory.menuRegistration.categoryId,
} as const;
